export enum EventBusEventsEnum {
    SNACKBAR_SHOW = 'SNACKBAR_SHOW',
}
